<template>
    <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOut">
        <span class="tooltiptext" v-if="value"><slot></slot></span>
    </transition>
</template>

<script>
    export default {
        props: ['value'],
        watch: {
            value: function(newVal,oldVal){
                if (newVal == true) {
                    let vm = this
                    setTimeout(() => {
                        vm.$emit('input',false)
                    }, 1000);
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/Tooltip.vue